import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

export function OfflineBanner() {
  const isOnline = useNetworkStatus();

  return (
    <Collapse in={!isOnline}>
      <Alert
        icon={<WifiOffIcon />}
        severity="warning"
        variant="filled"
        sx={{ borderRadius: 0 }}
      >
        Nessuna connessione — le operazioni riprenderanno quando torni online.
      </Alert>
    </Collapse>
  );
}
